import { useEffect } from 'react';
import { useRouteError } from 'react-router-dom';
import { Link } from 'react-router-dom';
import { reportError } from '../../services/logs/logs.service';
import classes from './base-error-boundary.module.scss';

export const BaseErrorBoundary = () => {
    const error = useRouteError() as Error;

    useEffect(() => {
        reportError({
            message: error?.message ?? 'Router error boundary',
            errorName: error?.name ?? 'RouteError',
            trace: error?.stack,
        });
    }, [error]);

    return (
        <div className={classes.container}>
            <h1>משהו בלתי צפוי קרה!</h1>
            <p>{error.message}</p>
            <Link to="/">רענן מערכת ונסה שנית</Link>
        </div>
    );
};
